import React, { createContext, useState, useContext } from 'react';

export const UsersContext = createContext();

const initialUsers = [
  { id: 'u0', name: 'Dev Root',    email: 'dev@system.internal', password: 'superadmin123', role: 'superadmin', status: 'active', createdAt: new Date(Date.now() - 86400000 * 60).toISOString() },
  { id: 'u1', name: 'Sarah Owner', email: 'sarah@company.com',   password: 'admin123',      role: 'admin',      status: 'active', createdAt: new Date(Date.now() - 86400000 * 30).toISOString() },
  { id: 'u2', name: 'Mark Sales',  email: 'mark@company.com',    password: 'sales123',      role: 'sales',      status: 'active', createdAt: new Date(Date.now() - 86400000 * 10).toISOString() },
  { id: 'u3', name: 'Lisa Sales',  email: 'lisa@company.com',    password: 'sales123',      role: 'sales',      status: 'paused', createdAt: new Date(Date.now() - 86400000 * 5).toISOString() },
];

export const ROLES = {
  superadmin: { label: 'Super Administrador', level: 3 },
  admin:      { label: 'Administrador',       level: 2 },
  sales:      { label: 'Ventas',              level: 1 },
};

export const canManageUser = (actorRole, targetRole) => {
  if (actorRole === 'superadmin') return true;
  if (actorRole === 'admin') return targetRole !== 'superadmin';
  return false;
};

export const visibleUsersFor = (users, actorRole) => {
  if (actorRole === 'superadmin') return users;
  return users.filter(u => u.role !== 'superadmin');
};

export const hasOtherActiveSuperAdmin = (users, excludeId) =>
  users.some(u => u.role === 'superadmin' && u.status === 'active' && u.id !== excludeId);

export const UsersProvider = ({ children }) => {
  const [users, setUsers] = useState(
    () => JSON.parse(localStorage.getItem('crm_users')) || initialUsers
  );
  const [currentUserId, setCurrentUserId] = useState(null);

  const persist = (updated) => {
    setUsers(updated);
    localStorage.setItem('crm_users', JSON.stringify(updated));
  };

  const currentUser = users.find(u => u.id === currentUserId) || null;

  const loginUser = (email, password) => {
    const user = users.find(u => u.email === email && u.password === password && u.status === 'active');
    if (user) { setCurrentUserId(user.id); return user; }
    return null;
  };

  const logoutUser = () => setCurrentUserId(null);

  const getVisibleUsers  = () => visibleUsersFor(users, currentUser?.role);
  const getUserById      = (id) => users.find(u => u.id === id);

  const addUser = (data) => {
    const safeRole = data.role === 'superadmin' ? 'admin' : data.role;
    persist([...users, { ...data, role: safeRole, id: Date.now().toString(), createdAt: new Date().toISOString(), status: 'active' }]);
  };

  const updateUser = (id, updates) => {
    const safeUpdates = { ...updates };
    if (currentUser?.role !== 'superadmin' && safeUpdates.role === 'superadmin') delete safeUpdates.role;
    persist(users.map(u => (u.id === id ? { ...u, ...safeUpdates } : u)));
  };

  const changePassword = (id, _newPassword) => {
    persist(users.map(u => (u.id === id ? { ...u, passwordChangedAt: new Date().toISOString() } : u)));
  };

  const setStatus = (id, status) => {
    const target = users.find(u => u.id === id);
    if (!target) return 'Usuario no encontrado.';
    const deactivating = ['paused', 'blocked', 'archived'];
    if (target.role === 'superadmin' && deactivating.includes(status) && !hasOtherActiveSuperAdmin(users, id))
      return 'Debe permanecer al menos un Super Administrador activo. Agrega otro primero.';
    persist(users.map(u => (u.id === id ? { ...u, status } : u)));
    return null;
  };

  return (
    <UsersContext.Provider value={{ users, currentUser, currentUserId, setCurrentUserId, loginUser, logoutUser, getVisibleUsers, getUserById, addUser, updateUser, changePassword, setStatus }}>
      {children}
    </UsersContext.Provider>
  );
};

export const useUsers = () => useContext(UsersContext);